"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultNewProgressPictureData = exports.getDefaultUnitPreference = exports.getDefaultFollowerData = exports.defaultLocationData = exports.defaultPhoneNumberFormat = exports.defaultDateFormat = void 0;
const utils_1 = require("../utils");
const constants_1 = require("./constants");
exports.defaultDateFormat = "YYYY-MM-DD";
exports.defaultPhoneNumberFormat = "e164";
exports.defaultLocationData = {
    city: "unknown",
    countryName: "unknown",
    countryCode: "un",
};
const getDefaultFollowerData = ({ username, displayName, avatarUrl, }) => ({
    username,
    displayName,
    avatarUrl,
    usernames: [],
    displayNames: [],
    avatarUrls: [],
    followRequests: [],
});
exports.getDefaultFollowerData = getDefaultFollowerData;
const getDefaultUnitPreference = () => (0, utils_1.getUnitPreference)(constants_1.Unit.METRIC);
exports.getDefaultUnitPreference = getDefaultUnitPreference;
// TODO: Fix ALL caps keys (WEIGHT, BODYFAT) - db migration needed for this
const getDefaultNewProgressPictureData = (override = {}) => (Object.assign({ date: null, images: {
        FRONT: null,
        BACK: null,
        SIDE: null,
    }, WEIGHT: {}, BODYFAT: null, privacy: null }, override));
exports.getDefaultNewProgressPictureData = getDefaultNewProgressPictureData;
//# sourceMappingURL=defaults.js.map